import { ApolloLink } from "./ApolloLink.js";
export var empty = ApolloLink.empty;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/empty.js
// module id = ./node_modules/@apollo/client/link/core/empty.js
// module chunks = 53 54